'use es6';

import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import { EARTH_LAYER } from 'HubStyleTokens/sizes';
import { SaveBarContainer } from 'customer-data-properties/savebar/SaveBarContainer';
import { universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import UITruncateString from 'UIComponents/text/UITruncateString';
import styled from 'styled-components';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFooter = styled.div.withConfig({
  displayName: "UniversalSidebarFooter__StyledFooter",
  componentId: "sc-35cgge-0"
})(["background:", ";border-top:1px solid ", ";position:sticky;bottom:0;left:0;right:0;z-index:", ";"], GYPSUM, BATTLESHIP, EARTH_LAYER);
export const UniversalSidebarFooter = ({
  formattedChanges,
  hasErrors,
  handleSave,
  handleCancel,
  hasChanges
}) => {
  return /*#__PURE__*/_jsxs(StyledFooter, {
    className: "p-x-4",
    "data-selenium-test": "preview-footer-refactor",
    children: [/*#__PURE__*/_jsx(UITruncateString, {
      className: "p-y-3",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataSidebar.boundedSaveBar.info",
        options: {
          changes: formattedChanges
        }
      })
    }), /*#__PURE__*/_jsxs(UIButtonWrapper, {
      className: "p-bottom-5",
      children: [/*#__PURE__*/_jsx(UIButton, {
        disabled: hasErrors || !hasChanges,
        onClick: handleSave,
        "data-selenium-test": "PreviewSaveBar-button-primary",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataSidebar.boundedSaveBar.saveButtonText"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        disabled: !hasChanges,
        "data-selenium-test": "PreviewSaveBar-button",
        onClick: handleCancel,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataSidebar.boundedSaveBar.cancelButtonText"
        })
      })]
    })]
  });
};
UniversalSidebarFooter.propTypes = {
  formattedChanges: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  hasChanges: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired
};
const ConnectedUniversalSidebarFooter = SaveBarContainer(UniversalSidebarFooter, universalEditableAreas);
export default ConnectedUniversalSidebarFooter;